<template>
    <div  ref="mainref">
        <div v-if="generalReportData!=null && (!inPrint || generalReportData.pageList.length==0)">
            <!-- titles -->
            <div class="vertFlex" >
                <p class="generaltitle" v-if="generalReportData.title!=null">{{generalReportData.title}}</p>
                <p class="generalsubtitle" v-if="generalReportData.subTitle!=null">{{generalReportData.subTitle }} </p>
                <p class="generalsubtitle2" v-if="generalReportData.subTitle2!=null">{{generalReportData.subTitle2 }} </p>
                <p class="generalsubtitle2" v-if="generalReportData.subTitle3!=null">{{generalReportData.subTitle3 }} </p>
                <p class="generalsubtitle2" v-if="generalReportData.subTitle4!=null">{{generalReportData.subTitle4 }} </p>
                <p class="generalsubtitle2" v-if="generalReportData.subTitle5!=null">{{generalReportData.subTitle5 }} </p>
                <p class="generalsubtitle2" v-if="generalReportData.subTitle6!=null">{{generalReportData.subTitle6 }} </p>
                <p class="generalsubtitle2" v-if="generalReportData.subTitle7!=null">{{generalReportData.subTitle7 }} </p>
            </div>

            <!-- vertFlex was part of clsas below -->
            <div class=" grid-container-flat" >
                <!-- superheaders ****may need some sticky header love-->
                <!-- <div class="horizFlex borderedrow cell header2">-->
                    <div v-for="o in generalReportData.superHeaders" :key="o" :value="o" :class="superheaderdivclasspre(o)">
                        <div :class="superheaderdivclass(o)">
                            <p class="valuelabelfixed bold  "  >{{ o.value }}</p>

                        </div>
                        
                    </div> 
                <!-- </div> -->

                <!-- headers: to do grid flavor, comment out the outer div here-->
                <!-- <div class="horizFlex borderedrow  header2 "> -->
                    <div v-for="o in generalReportData.headers" :key="o" :value="o" :class="headerdivclasspre(o)">
                        <div :class="headerdivclass(o)">
                            <p class="valuelabelfixed bold  " >{{ o.value }}</p>
                            
                            <!-- <linkbutton  @click="setsort(o)" :toplabel="o.value"/> -->
                        </div>
                    </div>
                <!-- </div> -->
                
                
                <!-- flat items: to do grid flavor, comment out the items section, and uncomment this secion-->
                <div :class="valuedivclass(o)" v-for="o in filteredFlatItems" :key="o" :value="o" >
                    <div class="horizFlex">
                        <linkbutton v-if="showAsLink(o)" :toplabel="o.value" :class="valueclass(o)"  @click="toggle(o)"/>
                        <p :class="valueclass(o)" v-if="!showAsLink(o)">{{o.value}}</p>
                        
                        <div v-if="showButton1(o)">
                            <button :class="buttonClass(1,o)" @click="doButton1(o)">{{ o.button1Text }}</button>
                        </div>
                        <div v-if="showButton2(o)">
                            <button :class="buttonClass(2,o)" @click="doButton2(o)">{{ o.button2Text }}</button>
                        </div>

                    </div>
                    
                </div>

                <!-- footers -->
                <div class="horizFlex borderedrow">
                    <div v-for="o in generalReportData.footers" :key="o" :value="o" :class="footerdivclass(o)">
                        <p class="valuelabelfixed  bold" >{{o.value}}</p>
                    </div>
                </div>

            </div>

            
        </div>
       
        
        <confirm ref="confirmprof" :noclick="!allowSetProficiency"  :showButton="paramFalse" body="Do you want to update the proficiency?" :title="titleToConfirm"
                                        @yes="toggleProficient()" /> 

    </div>

   <!--  for printing -->
   <div ref="mainrefprint" >
        <div v-if="generalReportData!=null && generalReportData.pageList.length>0 && inPrint">
            <!-- titles -->
            <div class="vertFlex" >
                <p class="generaltitle" v-if="generalReportData.title!=null">{{generalReportData.title}}</p>
                <p class="subtitleprint" v-if="generalReportData.subTitle!=null">{{generalReportData.subTitle }} </p>
                <p class="subtitleprint" v-if="generalReportData.subTitle2!=null">{{generalReportData.subTitle2 }} </p>
                <p class="subtitleprint" v-if="generalReportData.subTitle3!=null">{{generalReportData.subTitle3 }} </p>
                <p class="subtitleprint" v-if="generalReportData.subTitle4!=null">{{generalReportData.subTitle4 }} </p>
                <p class="subtitleprint" v-if="generalReportData.subTitle5!=null">{{generalReportData.subTitle5 }} </p>
                <p class="subtitleprint" v-if="generalReportData.subTitle6!=null">{{generalReportData.subTitle6 }} </p>
                <p class="subtitleprint" v-if="generalReportData.subTitle7!=null">{{generalReportData.subTitle7 }} </p>
            </div>



            <!-- for each page -->
            <div  v-for="o in generalReportData.pageList" :key="o.id" :value="o.id" >
               <!--  <div v-if="((o.id-12) % 19 == 0) || o.id==12" >
                    <div class="page-break" v-if="o.id>0"></div> -->
                <div v-if="(o.id % 19 == 0)" >
                    <div class="page-break" ></div>
                    <p class="subtitleprint" v-if="generalReportData.subTitle!=null">{{generalReportData.subTitle }} </p>
                    <br>
                      <div :class="printdivclass(o)">
                        <div v-for="h in getheaderlist(o.header_leftHeaderIndex,o.header_leftHeaderIndex)" :key="h.id" :value="h.id" :class="headerdivclasspre(h)">
                            <div :class="headerdivclass(h)">
                                <p class="valuelabelfixedprint bold  " >{{ h.value }}</p>
                            </div>
                        </div>
                        <div v-for="h in getheaderlist(o.header_index1,o.header_index2)" :key="h.id" :value="h.id" :class="headerdivclasspre(h)">
                            <div :class="headerdivclass(h)">
                                <p class="valuelabelfixedprint bold  " >{{ h.value }}</p>
                            </div>
                        </div>
                    </div> 
                    
                </div>
                
                
                <div :class="printdivclass(o)">
                    
                    <div v-for="h in getheaderlist(o.leftHeaderIndex,o.leftHeaderIndex)" :key="o" :value="o" :class="headerdivclasspre(h)" v-if="o.leftHeaderIndex< generalReportData.headers.length && o.id!=0">
                            <div :class="headerdivclass(h)">
                                <p class="valuelabelfixedprint bold  " >{{ h.value }}</p>
                            </div>
                    </div>
                    <div v-for="h in getheaderlist(o.index1,o.index2)" :key="h.id" :value="h.id" :class="headerdivclasspre(h)" v-if="o.index1< generalReportData.headers.length && o.id!=0">
                        <div :class="headerdivclass(h)">
                            <p class="valuelabelfixedprint bold  " >{{ h.value }}</p>
                        </div>
                    </div>
                    <div :class="valuedivclassprint(i)" v-for="i in getitemlist(o.leftHeaderIndex,o.leftHeaderIndex)" :key="i" :value="i" >
                        <div class="horizFlex">
                            <p :class="valueclassprint(i)" >{{i.value}}</p>
                        </div>
                        
                    </div>
                    <div :class="valuedivclassprint(i)" v-for="i in getitemlist(o.index1,o.index2)" :key="i" :value="i" >
                        <div class="horizFlex">
                            <p :class="valueclassprint(i)" >{{i.value}}</p>
                        </div>
                        
                    </div>
                </div>
                
            </div>
            
        </div>
        
    </div>          
</template>
    
<script>
      import {mapFields} from 'vuex-map-fields'
    import format from '../../format.js'
    import linkbutton from '../controls/linkbutton.vue';
    import confirm from '../actions/confirm.vue'
     import securityhelper from '../../services/securityhelper.js'
    export default {
        name:'generalreportflat',
        components:{
            linkbutton,
            confirm

        },
        props:{
            generalReportData:{
                type:Object,
            },
            tagClassListForValues:{
                type:Array,
                default:null
            },
            colwidth:{
                type:String,
                default:'120px'
            },
            colwidth_wide:{
                type:String,
                default:'240px'
            },
            scrollHeight:{
                type:Number,
                default:0
            },
      
           
    
        },
        watch:{
            generalReportData(newVal,oldVal){
                //clear header list
                this.headerList=[]
                console.log('in watch')
                 if(this.$refs.mainref){
                    if(this.generalReportData.headers.length>0){
                        var ct = this.generalReportData.headers.length -1
                        console.log('setcol in watch ' + ct)
                        document.body.style.setProperty('--colcount',ct );
                        this.$refs.mainref.style.setProperty('--colcount',ct);
                    }
                    
                 }
                 if(this.$refs.mainrefprint){
                    if(this.generalReportData.pageList.length>0){
                        if(this.generalReportData.pageList[0].colsThisPage>0){
                            var ct = this.generalReportData.pageList[0].colsThisPage
                            console.log('setcolp in watch ' + ct)
                            document.body.style.setProperty('--colcountprint',ct );
                            this.$refs.mainrefprint.style.setProperty('--colcountprint',ct);
                        }
                        var lastpageindex=this.generalReportData.pageList.length-1
                        if(this.generalReportData.pageList[lastpageindex].colsThisPage>0){
                            var ct = this.generalReportData.pageList[lastpageindex].colsThisPage
                            console.log('setcolpl in watch ' + ct)
                            document.body.style.setProperty('--colcountprintlast',ct );
                            this.$refs.mainrefprint.style.setProperty('--colcountprintlast',ct);
                        }
                    }
                    
                 }
                // document.body.style.setProperty('--colcount',this.generalReportData.headers.length-1 );
            }
        },
        mixins:[format,securityhelper],
        data(){
            return{
                headerList:[],
                lastHeaderIndex1_left:0,
                lastHeaderIndex1_top:0,
                lastHeaderIndex2_top:0,

                paramFalse:false,

                typeToConfirm:null,
                idToConfirm:0,
                titleToConfirm:null,

                sortBy:-1,
                sortaccending:true,

                //this is a sample. Any set of tag class mappings can be sent in to override the default
                defaultTagClassListForValues:[
                    {
                        tag:'Pass',
                        class:'passlabel'
                    },
                    {
                        tag:'Fail',
                        class:'faillabel'
                    },
                    {
                        tag:'Pass-Inactive',
                        class:'passlabel-inactive'
                    },
                    {
                        tag:'Fail-Inactive',
                        class:'faillabel-inactive'
                    },
                    {
                        tag:'Pass-Background',
                        class:'passbackground'
                    },
                    {
                        tag:'Fail-Background',
                        class:'failbackground'
                    }
                ]
            }
        },
        computed:{
            ...mapFields([

              'inPrint'
              
             

             
          ]),

            getheaderlist(){
                return (start, end)=>{
                    //if(start==end){this.lastHeaderIndex1_left=start}else{this.lastHeaderIndex1_top=start;this.lastHeaderIndex2_top=end}
                    return this.generalReportData.headers.slice(start, end+1)
                }
                /* var filt=[]
                //first see if we have it
                this.headerList.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                        let comp=arr[index]
                        if(i1==comp.index){
                            filt=comp.list
                        }
                    }
                if(filt.length>0){
                    console.log('found header list! ' + i1)
                    if(i1==i2){this.lastHeaderIndex1_left=i1}else{this.lastHeaderIndex1_top=i1;this.lastHeaderIndex2_top=i2}
                    return filt
                }
                else{
                    //if we didn't get it yet
                    this.generalReportData.headers.forEach(myFunction2)
                        function myFunction2(item, index, arr) {
                            let comp=arr[index]
                            if(index>=i1 && index <=i2){
                                filt.push(comp)
                            }
                        }
                        console.log('header count ' + i1 + ' ' + i2 + ' ' + filt.length)
                    if(filt.length>0){
                        //add to our list
                        console.log('added new header list... ' + i1)
                        var newheaderlist = {index:i1, list:filt}
                        this.headerList.push(newheaderlist)
                    }
                    if(i1==i2){this.lastHeaderIndex1_left=i1}else{this.lastHeaderIndex1_top=i1;this.lastHeaderIndex2_top=i2}
                    return filt
                } */
                
            },


            filteredFlatItems(){
                if(this.generalReportData==null){return []}
                if(this.generalReportData.parentChildList==null){return this.generalReportData.flatItems}
                if(this.generalReportData.parentChildList.length==0){return this.generalReportData.flatItems}
                var filt=[]

                var mythis = this
                this.generalReportData.flatItems.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                        let comp=arr[index]
                        if(mythis.isExpanded(comp.parentChildName) || comp.isParent){
                            filt.push(comp)
                        }
                    }
                return filt
                
            },
            sortedItems(){
                if(this.sortBy==-1){return this.generalReportData.items}

                var sort1 = this.sortaccending ? -1:1
                var sort2 = this.sortaccending ? 1:-1
                var selSortBy = this.sortBy

                //determine if this col is numbers
                if(this.isNumbers(selSortBy)){
                    function compare(a,b){
                        if (Number(a.values[selSortBy].value) < Number(b.values[selSortBy].value))
                            return sort1
                        if(Number(a.values[selSortBy].value) > Number(b.values[selSortBy].value))
                            return sort2
                        return 0
                    }
                    return this.generalReportData.items.sort(compare)
                }else{
                    function compare(a,b){
                        if (a.values[selSortBy].value < b.values[selSortBy].value)
                            return sort1
                        if(a.values[selSortBy].value > b.values[selSortBy].value)
                            return sort2
                        return 0
                    }
                    return this.generalReportData.items.sort(compare)
                }

                

            },
            itemdivclass(){
                if(this.scrollHeight>0){
                    return "scrollvertgeneral"
                }else{return ""}
            },
            //prof
            allowSetProficiency(){
                
                return this.canAccess('Set Proficiency')
            },
           
        },
        
        mounted(){
            this.updateProps()
        },
        
        methods:{
           //for print paging
           printdivclass(page){
            var firstpagecount = this.generalReportData.pageList[0].colsThisPage
            var thispagecount = page.colsThisPage
            if(thispagecount<firstpagecount){
                return "grid-container-flat-print-last"
            }else{return "grid-container-flat-print"}
            /* var dif= Number(page.index2)-Number(page.index1)
           // console.log('page dif ' + page.index2 + ' ' + page.index1 + ' ' + dif)
            if(Number(page.index2)-Number(page.index1)<6){
                return "grid-container-flat-print-last"
            }else{return "grid-container-flat-print"} */
           },
            
            getitemlist(i1,i2){
                var filt=[]
                this.generalReportData.flatItems.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                        let comp=arr[index]
                        if(index>=i1 && index <=i2){
                            filt.push(comp)
                        }
                    }
                return filt
            },



            toggle(o){
                console.log('toggle ' + o.parentChildName)
                var pcname = o.parentChildName
                //look for a match
                this.generalReportData.parentChildList.forEach(myFunction2)
                function myFunction2(item, index, arr) {
                    let tc=arr[index]
                    if(tc.parentChildName==pcname){
                        tc.isExpanded= !tc.isExpanded
                    }
                }

            },
            isExpanded(pcname){
                var isexp =false
                this.generalReportData.parentChildList.forEach(myFunction2)
                function myFunction2(item, index, arr) {
                    let tc=arr[index]
                    if(tc.parentChildName==pcname){
                        isexp= tc.isExpanded
                    }
                }
                return isexp
            },
            
            showAsLink(o){
                return o.isParent && o.index ==0
            },
            setcolcount(ct){
                console.log('setcolcount method ' + ct)
                document.body.style.setProperty('--colcount',ct );
                 //this.$refs.mainref.style.setProperty('--colcount',ct);
            },
            isNumbers(index){
                var isnumeric = true
                var ex = this.generalReportData.items[0].values[index].value
                //console.log(ex)
                if(isNaN(ex)){isnumeric=false}
                //console.log(index + ' numeric ' + isnumeric)
                return isnumeric
            },
            updateProps(){
                if(this.colWidth!='120px'){
                    document.body.style.setProperty('--colwidth',this.colwidth);
                    document.body.style.setProperty('--colwidth_wide',this.colwidth_wide);
                }
                if(this.scrollHeight>0) {
                    document.body.style.setProperty('--scrollheightflat',this.scrollHeight + 'px');
                }
                
                if(this.generalReportData!=null){
                    if(this.generalReportData.headers.length>0){
                        this.$nextTick(()=>{
                            document.body.style.setProperty('--colcount',ct );
                            if(this.$refs.mainref){
                                var ct = this.generalReportData.headers.length -1
                                console.log('setcol ' + ct)
                                this.$refs.mainref.style.setProperty('--colcount',ct);
                            }
                            
                        })
                    }
                    
                }
                
            },
            setsort(h){
                //if didn't change col, toggle asc/desc
                if(h.index==this.sortBy){this.sortaccending=!this.sortaccending}
                this.sortBy=h.index
                
            },
            itemclass(s){
                //handle inactive class
                var c = "horizFlex borderedrow"
                if(!s.isActive){ c = c + " inactiveItem"}
                return c
            },
            valueclass(o){
                var cls = ""
                cls=cls + this.getLabelWidthClass(o.tag) + this.getLabelFormatClass(o.tag)
                // if(o.isParent && o.index ==0){cls = cls + ' padleftparent'}
                if(o.isChild && o.index==0){cls = cls + ' padleftchild'}
                return cls
            },
            valueclassprint(o){
                var cls = "valueprint "
                cls=cls + this.getLabelWidthClass(o.tag) + this.getLabelFormatClass(o.tag)
                // if(o.isParent && o.index ==0){cls = cls + ' padleftparent'}
                //if(o.isChild && o.index==0){cls = cls + ' padleftchild'}
                return cls
            },
            valuedivclass(o){
                var cls = ""
                cls = cls +  this.getLeftPadAndBorderClass(o.index)
                if(o.tag=='wide'){cls = cls + " cell side-header"}
                
                // if(o.tag=='wide'){cls = cls + " cell side-header"}
                else{
                    cls = cls + " cell"
                }
                if(!o.isActive){cls = cls + ' inactiveItem'}
                if(o.isParent && o.index ==0){cls = cls + ' padleftparent'}
                return cls
            },
            valuedivclassprint(o){
                var cls = ""
                cls = cls +  this.getLeftPadAndBorderClass(o.index)
                if(o.tag=='wide'){cls = cls + " cell side-headerprint"}
                
                // if(o.tag=='wide'){cls = cls + " cell side-header"}
                else{
                    cls = cls + " cell"
                }
                if(!o.isActive){cls = cls + ' inactiveItem'}
                //if(o.isParent && o.index ==0){cls = cls + ' padleftparent'}
                return cls
            },
            showButton1(o){
                if(o.button1Text==undefined){return false}
                return o.button1Text!=null
            },
            showButton2(o){
                if(o.button2Text==undefined){return false}
                return o.button2Text!=null
            },
            headerdivclass(o){
                var cls ="bottompad bold "
                cls=cls + this.getLabelWidthClass(o.tag) + this.getLeftPadAndBorderClass(o.index)
                return cls
            },
            headerdivclasspre(o){
                var cls =""
                
                 if(this.generalReportData.superHeaders.length==0){ //if no supers, give those kind of classes to the headers
                     if(o.index==0){cls = cls + "  cell supercorner-headerflat "}
                    else{cls = cls + " cell header2s"}
                 }else{
                    if(o.index==0){cls = cls + "   cell corner-headerflat"}
                    else{cls = cls + " cell header2flat"}
                 }

                 
                return cls
            },
            superheaderdivclass(o){
                var cls ="topbottompad bold"
                cls=cls + this.getLabelWidthClass(o.tag) + this.getLeftPadAndBorderClass(o.index)
                return cls
            },
            superheaderdivclasspre(o){
                var cls =""
    
                 if(o.index==0){cls = cls + "  cell supercorner-headerflat "}
                 else{cls = cls + " cell header2s"}
                return cls
            },
            footerdivclass(o){
                var cls ="topbottompad"
                cls=cls + this.getLabelWidthClass(o.tag) + this.getLeftPadAndBorderClass(o.index)
                return cls
            },
            isFirstOfGroup(index){
               // console.log('sh ' + index)
                //return true
                //if there aren't any superheaders, then every header is  first, else, any header with a corresponding superheader is a first
                if(this.generalReportData==null){return true}
                if(this.generalReportData.superHeaders.length==0){return true}
                if(this.generalReportData.superHeaders.length<=index){return true}
                if(this.generalReportData.superHeaders[index].value!=""){return true}
                else return false
            },
            getLabelWidthClass(tag){
                if(tag=='wide'){return " valuelabelfixedwide"}else{return " valuelabelfixed"}
            },
            getLeftPadAndBorderClass(index){
                if(this.isFirstOfGroup(index)){return " leftpadandborder"}else{return ""}
            },
            //use the tagclass mapping array to add specific class to the value label
            getLabelFormatClass(tag){
                if(tag===null || tag==''){return ""}
                var cls=""

                //if passed in, use those, else use default
                if(this.tagClassListForValues!=null){this.defaultTagClassListForValues=this.tagClassListForValues}
               
                //look for a match
                this.defaultTagClassListForValues.forEach(myFunction2)
                function myFunction2(item, index, arr) {
                    let tc=arr[index]
                    if(tc.tag==tag){
                        cls=tc.class
                    }
                }
   
                return ' ' + cls
            },


            //PROFICIENCY STUFF FOR PRECDL
             toggleProficient(){
                //idToConfirm,typeToConfirm
                this.$emit('toggleproficiency',this.idToConfirm, this.typeToConfirm)
            },
            
            buttonClass(index,o){
                if(index==1){
                    if(o.button1Text.includes('NOT Proficient')){
                        if(this.allowSetProficiency){
                            return "buttonred innerbtn"
                        }else{
                            return "buttonred_light innerbtn"
                        }
                    }
                    if(o.button1Text.includes('IS Proficient')){
                        if(this.allowSetProficiency){
                            return "buttongreen innerbtn"
                        }else{
                            return "buttongreen_light innerbtn"
                        }
                    }
                }else{
                    if(o.button2Text.includes('NOT Proficient')){
                        if(this.allowSetProficiency){
                            return "buttonred innerbtn"
                        }else{
                            return "buttonred_light innerbtn"
                        }
                    }
                    if(o.button2Text.includes('IS Proficient')){
                        if(this.allowSetProficiency){
                            return "buttongreen innerbtn"
                        }else{
                            return "buttongreen_light innerbtn"
                        }
                    }
                    
                }
                
            },
            
            doButton1(o){
                console.log("button 1")
                if(o.button1Text.includes('Proficient')){
                    if(o.button1Text.includes('ROAD')){this.typeToConfirm='road'}
                    else{this.typeToConfirm='range'}

                    this.idToConfirm=o.idForButton
                    this.titleToConfirm=o.button1Text
                    this.$refs.confirmprof.Show()
                }
                
            },
            doButton2(o){
                console.log("button 2")
                if(o.button2Text.includes('Proficient')){
                    if(o.button2Text.includes('ROAD')){this.typeToConfirm='road'}
                    else{this.typeToConfirm='range'}

                    this.idToConfirm=o.idForButton
                    this.titleToConfirm=o.button2Text
                    this.$refs.confirmprof.Show()
                }

            },
            
        }
    }
</script>
    
<style>
:root{
    --padding:10px;
    --paddingsmall:5px;
    --inactivecolor:rgb(228, 223, 223);
    --linecolor:rgb(197, 190, 190);
    --colwidth:120px;
    --colwidth_wide:240px;
    --scrollheightflat:520px;
    /* --colcount:10; */
    /* --colcountprint:7;
    --colcountprintlast:1; */
}
@media print{
    .page-break {
        page-break-before: always;
    }
    .grid-container-flat {
        font-size:smaller;
        /* to try grid, uncomment the three grid lines below */
        display: grid; 
        grid-template-columns: auto repeat(var(--colcount), auto); 
        grid-auto-rows: auto;  
    
        max-height: none !important; /* remove scroll restriction */
        overflow: visible !important; /* show all content */
        /* border: 1px solid #ccc; */
        position: relative;
    }
    .grid-container-flat-print {
        font-size:smaller;
        /* to try grid, uncomment the three grid lines below */
        display: grid; 
        grid-template-columns: auto repeat(var(--colcountprint), auto); 
        grid-auto-rows: auto;  
    
        max-height: none !important; /* remove scroll restriction */
        overflow: visible !important; /* show all content */
        /* border: 1px solid #ccc; */
        position: relative;
    }
    .grid-container-flat-print-last {
        font-size:smaller;
        /* to try grid, uncomment the three grid lines below */
        display: grid; 
        grid-template-columns: auto repeat(var(--colcountprintlast), auto); 
        grid-auto-rows: auto;  
    
        max-height: none !important; /* remove scroll restriction */
        overflow: visible !important; /* show all content */
        /* border: 1px solid #ccc; */
        position: relative;
    }
    .scrollvertgeneral{
        max-height: none !important; /* remove scroll restriction */
        overflow: visible !important; /* show all content */
        margin:0px;
    }
}

 .scrollvertgeneral{
    height:var(--scrollheightflat);
  /* max-height:100%; */
  overflow-y: auto;
  overflow-x:hidden;
  margin:0px;
  }


p{
    margin:var(--padding) 0px var(--padding) 0px;
}
  .generaltitle{
    margin:var(--paddingsmall);
    font-size:larger;
    font-weight:bold;
  }
  .generalsubtitle{
    margin:var(--paddingsmall);
  }
   .generalsubtitle2{
    margin:var(--paddingsmall);
    /* font-size:small; */
    margin:0px;
  }
  .borderedrow{
    /* border-bottom:1px solid var(--linecolor); */
   
  }
  .topbottompad{
    padding:var(--padding) 0px var(--padding) 0px;
  }
  .bottompad{
    padding:0px 0px var(--padding) 0px;
  }
  .valuelabelfixed{
    width:var(--colwidth);
    min-width:var(--colwidth);
    text-align: left;
    
  }
  .valuelabelfixedwide{
    width:var(--colwidth_wide);
    min-width:var(--colwidth_wide);
    text-align: left;
  }
  .inactiveItem{
    background-color:var(--inactivecolor);
  }
  .leftpadandborder{
    padding-left:var(--padding);
    border-left:1px solid var(--linecolor);
  }
  .passlabel{
    color:green;
  }
  .faillabel{
    color:red;
  }
  .passlabel-inactive{
    color:green;
  }
  .faillabel-inactive{
    color:red;
  }
 

  .passbackground{
    background-color:rgb(183, 238, 183);
  }
  .failbackground{
    background-color:rgb(231, 179, 179);
  }



/* for double sticky headers */
.grid-container-flat {
    font-size:medium;
    /* to try grid, uncomment the three grid lines below */
       display: grid; 
      grid-template-columns: auto repeat(var(--colcount), auto); 
      grid-template-rows:75px;
       grid-auto-rows: auto;  
      width: 95vw;
      max-height: var(--scrollheightflat);
      overflow: auto;
      /* border: 1px solid #ccc; */
      position: relative;
    }
.grid-container-flat-print {
    font-size:medium;
    /* to try grid, uncomment the three grid lines below */
       display: grid; 
      grid-template-columns: auto repeat(var(--colcountprint), auto); 
      grid-template-rows:40px;
       grid-auto-rows: auto;  
      width: 95vw;
      max-height: none !important; /* remove scroll restriction */
        overflow: visible !important; /* show all content */
      /* border: 1px solid #ccc; */
      position: relative;
    }
    .grid-container-flat-print-last {
    font-size:medium;
    /* to try grid, uncomment the three grid lines below */
       display: grid; 
      grid-template-columns: auto repeat(var(--colcountprintlast), auto); 
      grid-template-rows:40px;
       grid-auto-rows: auto;  
      width: 95vw;
      max-height: none !important; /* remove scroll restriction */
        overflow: visible !important; /* show all content */
      /* border: 1px solid #ccc; */
      position: relative;
    }
    .cell {
        border-bottom:1px solid var(--linecolor);
   
      /* border: 1px solid #ccc; */
      /* padding: 10px; */
      /* background: white; */
    }

    .header2s {
      position: sticky;
      top: 0;
      background: #f8f8f8;
      z-index: 3;
    }
    .header2flat {
      position: sticky;
      top: 50px;
      background: #f8f8f8;
      z-index: 3;
    }
    .side-header {
      position: sticky;
      left: 0;
      background: #f0f0f0;
      z-index: 2;
      text-align: left;
      padding-top:0px;
      font-weight: bold;
    }
.side-headerprint{
  position: sticky;
      left: 0;
      background: #f0f0f0;
      z-index: 2;
      text-align: left;
      padding-top:0px;
      padding-left:10px;
      font-weight: bold;      
}
    .corner-headerflat {
      z-index: 4;
      position: sticky;
      top: 50px;
      left: 0;
      background: #f8f8f8;
    }
    .supercorner-headerflat {
      z-index: 4;
      position: sticky;
      top: 0;
      left: 0;
      background: #f8f8f8;
    }
    .padleftchild{
        padding-left:8px;
    }
    .padleftparent{
        padding-top:12px;
        
    }

.innerbtn{
    border: none;
border-radius:5px;
width:100px;
height:35px;
padding:0px;
font-size: medium;
margin:5px;
text-decoration: none;
}
    .buttongreen{
  background-color:var(--success-color);
  color:var(--light-text-color);
}
.buttonred{
  background-color:var(--alert-color);
  color:var(--light-text-color);
}
.buttongreen_light{
  background-color:rgb(162, 204, 162);
  color:var(--light-text-color);
}
.buttonred_light{
  background-color:rgb(233, 139, 139);
  color:var(--light-text-color);
}
.buttongreen_light:hover{
  font-weight:normal;
  cursor:default;
}
.buttonred_light:hover{
  font-weight:normal;
  cursor:default;
}


.valueprint{
    margin:0px 0px 0px 0px;
}
 .subtitleprint{
    margin:5px 0px 0px 5px;
  }
</style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    